export function getRole(authContext) {
    const permissionInfo = authContext.permissionState.permissionInfo;
    return permissionInfo.role_names[0]||'CLEANER';
}
export function getPermissionDataByKey(authContext,key) {
    const permissionInfo = authContext.permissionState.permissionInfo;
    return permissionInfo[key];
}
